import React, { useState, useEffect } from "react";
import Beer from "./beer";
import BeerDetails from "./beer-details";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { displayBeer } from "../actions/beerActions";

import { Modal, Alert, Spinner } from "react-bootstrap";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import ReactGA from 'react-ga4';

const Beers = ({ beers, displayBeer, selected, isLoading, error, searchQuery, isGivingUp, retryCount }) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: window.location.pathname + window.location.search });
  }, []);

  const displayDetails = beer => {
    displayBeer(beer); // dispatch selection action
    setModalIsOpen(true); // open modal
  };

  const closeModal = () => setModalIsOpen(false);

  const renderBeersList = () => {
    if (isGivingUp) {
      return (
        <div className="col-12">
          <Alert variant="info" className="shadow-sm border-0 py-4 text-center">
            <div className="display-4 mb-3">😔</div>
            <h3 className="fw-bold">We are sincerely sorry.</h3>
            <p className="lead">Despite our best efforts over 5 consecutive attempts, we cannot retrieve your health metrics right now.</p>
            <hr />
            <p className="mb-0 small text-muted">The ecosystem (Punk API & App Engine fallback) is currently unresponsive. 
            Please ensure your Oura ring data is synced to the mobile app and try refreshing this page in a few minutes.</p>
          </Alert>
        </div>
      );
    }

    if (error) {
      return (
        <div className="col-12">
          <Alert variant="warning" className="shadow-sm border-0">
            <FontAwesomeIcon icon="exclamation-triangle" className="me-2" />
            <strong>Service Connectivity Issue:</strong> {error}. {isLoading && <Spinner animation="border" size="sm" variant="dark" className="ms-2" />} <br/>
            <small className="text-dark">Retry attempt {retryCount}/5 will occur automatically in 30 seconds...</small>
          </Alert>
        </div>
      );
    }

    if (isLoading) {
      return (
        <div className="col-12 text-center my-5">
          <Spinner animation="border" variant="warning" className="mb-2" />
          <p className="text-muted">Retrieving health metrics from ecosystem...</p>
        </div>
      );
    }

    if (beers.length === 0)
      return (
        <div className="col-12 my-5 text-center fade-in">
          <FontAwesomeIcon className="beer-icon" icon="beer" size="5x" />
          <h4 className="mt-4 text-muted font-weight-light">
            {searchQuery 
              ? `No health records found for "${searchQuery}"` 
              : "No health data available in the current view."}
          </h4>
          <p className="small text-muted">Initiate a sync from your mobile device to generate new charts.</p>
        </div>
      );

    return beers.map(beer => (
      <Beer key={beer.id} beer={beer} onDetail={displayDetails} />
    ));
  };

  return (
    <>
      <div className="container">
        <div className="row row-eq-height py-5">{renderBeersList()}</div>
      </div>

      <Modal show={modalIsOpen} onHide={closeModal} size="lg">
        {modalIsOpen && !isLoading && (
          <BeerDetails beer={selected} onClose={closeModal} />
        )}
      </Modal>
    </>
  );
};

Beers.propTypes = {
  displayBeer: PropTypes.func.isRequired,
  selected: PropTypes.object.isRequired,
  isLoading: PropTypes.bool,
  error: PropTypes.string,
  searchQuery: PropTypes.string,
  isGivingUp: PropTypes.bool,
  retryCount: PropTypes.number
};

const mapStateToProps = state => ({
  selected: state.beer.selected,
  isLoading: state.beer.isLoading,
  error: state.beer.error,
  searchQuery: state.beer.searchQuery
});

export default connect(
  mapStateToProps,
  { displayBeer }
)(Beers);
